export type ConnectionState = "connecting" | "connected" | "reconnecting" | "disconnected";

const TONE: Record<ConnectionState, string> = {
  connecting: "pending",
  connected: "connected",
  reconnecting: "pending",
  disconnected: "lost",
};

const LABEL: Record<ConnectionState, string> = {
  connecting: "Connecting…",
  connected: "Connected",
  reconnecting: "Reconnecting…",
  disconnected: "Disconnected",
};

export interface ConnectionStatus {
  set(state: ConnectionState, detail?: string): void;
  dispose(): void;
}

export function createConnectionStatus(parent: HTMLElement = document.body): ConnectionStatus {
  const element = document.createElement("div");
  element.className = "connection-status connection-status--pending";
  element.textContent = LABEL.connecting;
  parent.appendChild(element);

  return {
    set: (state, detail) => {
      element.className = `connection-status connection-status--${TONE[state]}`;
      element.textContent = detail ? `${LABEL[state]} — ${detail}` : LABEL[state];
    },
    dispose: () => element.remove(),
  };
}

/**
 * Last resort when the game cannot run at all — an unreachable server, a failed
 * join. Readable text, not a silent blank canvas.
 */
export function showFatalError(title: string, detail: string): void {
  const overlay = document.createElement("div");
  overlay.className = "fatal-error";

  const heading = document.createElement("h2");
  heading.textContent = title;

  const body = document.createElement("p");
  body.textContent = detail;

  overlay.append(heading, body);
  document.body.appendChild(overlay);
}
